import { createContext, useContext } from 'react';

// Context for drawer styling
export const DrawerStyleContext = createContext<{ drawerHeaderDesign?: 'tab' | 'flex' }>({});
export const useDrawerStyleContext = () => useContext(DrawerStyleContext);
